<template>
  <div>
    <app-navbar/>
    <v-content>
        <v-container fluid>
           <v-layout row pb-2>
            <v-flex xs12>
              <v-card class="card--flex-toolbar">
                <v-toolbar card prominent>
                  <v-toolbar-title class="body-2 grey--text">TABLEAU DE BORD</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn flat>
                    Statistiques
                  </v-btn>

                  <v-btn flat>
                    Vue globale
                  </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text>
                  A venir bientot...
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
    </v-content>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Navbar from '@/components/comps/Navbar.vue'
import Footer from '@/components/comps/Footer.vue'
import router from "@/plugins/router";
import config from "../../config"

export default {
  name: "Home",
  mounted() {
    this.checkLoggedIn();
  },
  components: {
    'app-navbar' : Navbar,
    'app-footer' : Footer,
  },
  methods: {
     checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        router.push("/auth");
      }else{
         axios({
          method : 'get',
          url : config.api.baseurl+'/api/user',
          headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        })
        .then(response => {
          console.log(response)
          this.$session.set('user',response.data);
          router.push('/');
        }).catch(e=> {
          router.push("/auth");
        });
      }
    }
  }
};
</script>
